export default "__VITE_ASSET__B6YQHbBu__"